import React, { useState, useCallback, useEffect } from 'react';
import { Button, Card, CardBody, CardHeader, Container, Row } from 'reactstrap';

import ActiveWhatsappBlockListForm from './components/ActiveWhatsappBlockListForm';
import SimpleHeader from '../../../components/Headers/SimpleHeader';
import TemplateService from '../../Templates/service';
import Pagination from '../../../components/Pagination';
import Loader from '../../../components/Loader';

import { useListActiveWhatsappBlockList } from '../hooks/useListActiveWhatsappBlockList';
import { ActiveWhatsappBlockListTable } from './components/ActiveWhatsappBlockList';
import {
  useMemorizeFilters,
  POSSIBLE_FILTERS_ENTITIES
} from '../../../hooks/useMemorizeInputsFilters';
import ImportBlockedWhatsappNumbers from './components/ImportBlockedWhatsappNumber';
import BlockingWordsModal from './components/BlockingWordsModal';

const pageKey = 'flexTableConfig::[activeWhatsappBlock]';

const ActiveWhatsappBlockList = () => {
  const [activePage, setActivePage] = useState(1);
  const [dataToSend, setDataToSend] = useState({});
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: null
  });
  const [templates, setTemplates] = useState([]);

  const { memorizeFilters, getMemorizedFilters } = useMemorizeFilters(
    POSSIBLE_FILTERS_ENTITIES.WHATSAPP_BLOCK_LIST
  );

  const {
    getWhatsappBlockNumbers,
    whatsappBlockNumbersList,
    totalWhatsappBlockNumbers,
    isLoadingWhatsappBlockNumbers
  } = useListActiveWhatsappBlockList({
    sortConfig
  });

  const fetchTemplates = useCallback(() => {
    TemplateService.getAllTemplates()
      .then((response) => {
        const data = response?.data || [];
        setTemplates(data);
      })
      .catch((err) => console.error('Erro ao carregar templates:', err));
  }, []);

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  useEffect(() => {
    const { key, direction } = sortConfig.key
      ? sortConfig
      : JSON.parse(localStorage.getItem(pageKey)) || {
          key: null,
          direction: null
        };

    if (!key || !direction) return;

    handleSearch({
      ...getMemorizedFilters(),
      orderBy: key,
      orderType: direction
    });
  }, [sortConfig, handleSearch]);

  const handleSearch = useCallback(
    (searchFilters) => {
      const page = searchFilters?.page || 1;
      setActivePage(page);
      getWhatsappBlockNumbers(page, searchFilters);
    },
    [getWhatsappBlockNumbers]
  );

  const handlePageChange = (page) => {
    const currentFilters = getMemorizedFilters();
    memorizeFilters({ ...currentFilters, page });
    setActivePage(page);
    getWhatsappBlockNumbers(page, dataToSend);
  };

  return (
    <>
      <SimpleHeader
        setCreate={`/admin/chat/active-whatsapp-block-list/form`}
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/configuration"
      >
        <>
          <BlockingWordsModal
            buttonOpenModal={({ onClick }) => (
              <Button onClick={onClick}>Palavras para Bloqueio</Button>
            )}
          />
          <ImportBlockedWhatsappNumbers
            buttonOpenModal={({ onClick }) => (
              <Button onClick={onClick}>Importar</Button>
            )}
          />
        </>
      </SimpleHeader>
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">
                    Lista de números bloqueados do WhatsApp
                  </h3>
                </CardHeader>
                <CardBody className="pt-2">
                  <ActiveWhatsappBlockListForm
                    handleSearch={handleSearch}
                    totalWhatsappBlockNumbers={totalWhatsappBlockNumbers}
                    whatsappBlockNumbersList={whatsappBlockNumbersList}
                    setDataToSend={setDataToSend}
                    templates={templates}
                  />

                  {isLoadingWhatsappBlockNumbers ? (
                    <div className="col-12">
                      <Row className="justify-content-md-center">
                        <Loader />
                      </Row>
                    </div>
                  ) : (
                    <>
                      <ActiveWhatsappBlockListTable
                        handleSearch={handleSearch}
                        data={whatsappBlockNumbersList}
                        setSortConfig={setSortConfig}
                        sortConfig={sortConfig}
                        templates={templates}
                      />
                      <Pagination
                        activePage={activePage}
                        totalItemsCount={totalWhatsappBlockNumbers}
                        onChange={handlePageChange.bind(this)}
                      />
                    </>
                  )}
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ActiveWhatsappBlockList;
